import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { type Notice } from '~/features/notice/types/notice'
import NoData from '~/shared/components/NoData'
import theme from '~/shared/styles/theme'
import { fDate } from '~/shared/utils/format-date'

type Props = {
  data: Notice[]
}

function NoticeList({ data }: Props) {
  const navigate = useNavigate()

  if (data.length === 0) {
    return (
      <NoDataWrapper>
        <NoData />
      </NoDataWrapper>
    )
  }

  const handleClick = (id: number) => {
    navigate(`/notice/${id}`)
  }

  return (
    <Wrapper>
      {data.map((notice) => (
        <NoticeItem key={notice.id} onClick={() => handleClick(notice.id)}>
          <CategoryBox>{notice.category_desc}</CategoryBox>
          <Title>{notice.title}</Title>
          <DateWrapper>
            <Date>{fDate(notice.updated_at, 'yyyy.MM.dd')}</Date>
          </DateWrapper>
        </NoticeItem>
      ))}
    </Wrapper>
  )
}

export default NoticeList

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: auto;

  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    gap: 20px;

    /* border: 1px solid red; */

    border: none;
    border-radius: 0;
  }
`

const NoticeItem = styled.div`
  cursor: pointer;

  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100%;
  height: 89px;
  padding: 24px;

  border-bottom: 1px solid #c1c3c2;

  @media ${theme.device.medium} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    height: 222px;

    border: 1px solid #c1c3c2;
    border-radius: 12px;

    &:last-child {
      border-bottom: 1px solid #c1c3c2;
    }
  }
`

const CategoryBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 164px;
  height: 41px;
  padding: 16px 8px;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  color: #313634;

  background-color: #eaebeb;
  border-radius: 60px;
`

const Title = styled.div`
  width: 668px;

  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #313634;
  text-align: left;

  @media ${theme.device.medium} {
    overflow: hidden;

    width: 100%;
    height: 64px;

    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: nowrap;
  }
`

const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 110px;
`

const Date = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #838685;
`

const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
`
